interface Props {
  agreed: boolean;
  onStart: () => void;
}

export function ConsentsPrompt({ agreed, onStart }: Props) {
  if (agreed) {
    return (
      <div className="status-alert status-alert--success">
        <p className="status-headline">Documents received.</p>
        <p>Thank you. Signed and sent to your care team.</p>
      </div>
    );
  }

  return (
    <div className="status-alert status-alert--info insurance-prompt">
      <p className="status-headline">Sign your consent forms</p>
      <p>It takes a few minutes and saves time for your nurse.</p>
      <button type="button" className="btn btn-primary" onClick={onStart}>
        Review documents
      </button>
    </div>
  );
}
